import { useState, useEffect } from 'react';
import { Outlet } from "react-router-dom";
import { AuthProvider } from '../context/authContext';
import TokenCheckProvider from '../context/tokenCheckProvider';

const getCookie = (name: string) => {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
        let cookie = cookies[i].trim();
        if (cookie.startsWith(name + '=')) {
            return cookie.split('=')[1];
        }
    }
    return null;
}

const ProtectedRoutes = () => {
    const [hasToken, setHasToken] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    
    useEffect(() => {
        const checkToken = () => {
            const token = getCookie('accessToken');
            setHasToken(!!token);
            setIsLoading(false);
        };

        // Check token immediately
        checkToken();

        // Set up an interval to check for token changes
        const interval = setInterval(checkToken, 1000);

        // Custom event listener for cookie changes
        const handleCookieChange = () => {
            checkToken();
        };

        const handleTokenExpired = () => {
            setHasToken(false);
        };

        window.addEventListener('cookieChange', handleCookieChange);
        window.addEventListener('tokenExpired', handleTokenExpired);

        return () => {
            clearInterval(interval);
            window.removeEventListener('cookieChange', handleCookieChange);
            window.removeEventListener("tokenExpired", handleTokenExpired);
        };
    }, []);


    if (isLoading) {
        return <div>Loading ...</div>
    }

    if (!hasToken) {
        window.location.href="/";
    }

    return (
        <AuthProvider>
            <TokenCheckProvider>
                <Outlet />
            </TokenCheckProvider>
        </AuthProvider>
    )
}

export default ProtectedRoutes